import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { useMediaBySize } from 'pricing-pages-ui-components/hooks/useMedia';
import MerchCardLayout from 'pricing-pages-ui-components/layouts/merch-cards/MerchCardLayout';
import { SingleSkeletonLoader } from 'pricing-pages-ui-components/loading/SingleSkeletonLoader';
import { HsocMerchCardGridLayout } from './HsocMerchCardGrid';

/* Mirrors HsocMerchCard's own card styling so the skeleton occupies the same
 * footprint as the real card it stands in for. */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CARD_STYLES = {
  paddingInline: '600',
  backgroundColor: 'fill-surface-default',
  borderRadius: '400',
  borderStyle: 'solid',
  borderColor: 'border-core-subtle',
  borderWidth: '100'
};

/* Real cards always list 5-7 features; 6 keeps the skeleton's Features slot
 * close to the real card's height instead of shifting the page once cards load. */
const FEATURE_ROW_COUNT = 6;
const HsocMerchCardGridSkeleton = ({
  showHeader = false
}) => {
  const isMd = useMediaBySize('md');
  /* v2 always shows 4 tiers (FREE/STARTER/PROFESSIONAL/ENTERPRISE) on md+
   * screens, unlike v1's 3. */
  const skeletonCount = isMd ? 4 : 1;
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "100%",
    maxInlineSize: isMd ? '1200px' : '450px',
    marginInline: "auto",
    children: [showHeader && /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "400",
      "data-selenium-id": "hsoc-merch-card-grid-skeleton-header",
      children: [/*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 40,
        width: "220px"
      }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 32,
        width: "160px"
      })]
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: showHeader ? '600' : '0',
      children: /*#__PURE__*/_jsx(HsocMerchCardGridLayout, {
        children: Array.from({
          length: skeletonCount
        }, (_, index) => /*#__PURE__*/_jsx(MerchCardLayout, {
          columnStart: index + 1,
          "data-selenium-id": "hsoc-merch-card-grid-skeleton",
          Title: /*#__PURE__*/_jsx(View, {
            paddingBlockStart: "600",
            children: /*#__PURE__*/_jsx(SingleSkeletonLoader, {
              height: 24
            })
          }),
          Subheading: /*#__PURE__*/_jsxs(View, {
            paddingBlockStart: "50",
            children: [/*#__PURE__*/_jsx(SingleSkeletonLoader, {
              height: 16
            }), /*#__PURE__*/_jsx(View, {
              paddingBlockStart: "100",
              children: /*#__PURE__*/_jsx(SingleSkeletonLoader, {
                height: 16,
                width: "70%"
              })
            })]
          }),
          Pricing: /*#__PURE__*/_jsx(View, {
            paddingBlockStart: "400",
            children: /*#__PURE__*/_jsx(SingleSkeletonLoader, {
              height: 20
            })
          }),
          Subtext: /*#__PURE__*/_jsx(View, {
            paddingBlockStart: "100",
            children: /*#__PURE__*/_jsx(SingleSkeletonLoader, {
              height: 16,
              width: "60%"
            })
          }),
          CTAs: /*#__PURE__*/_jsx(View, {
            paddingBlockStart: "500",
            children: /*#__PURE__*/_jsx(SingleSkeletonLoader, {
              height: 40
            })
          }),
          Features: /*#__PURE__*/_jsxs(View, {
            paddingBlockStart: "600",
            paddingBlockEnd: "600",
            children: [/*#__PURE__*/_jsx(View, {
              paddingBlockEnd: "400",
              children: /*#__PURE__*/_jsx(SingleSkeletonLoader, {
                height: 20,
                width: "50%"
              })
            }), Array.from({
              length: FEATURE_ROW_COUNT
            }, (_feature, featureIndex) => /*#__PURE__*/_jsx(View, {
              paddingBlockEnd: "300",
              children: /*#__PURE__*/_jsx(SingleSkeletonLoader, {
                height: 24
              })
            }, featureIndex))]
          }),
          cardStyles: CARD_STYLES
        }, index))
      })
    })]
  });
};
export default HsocMerchCardGridSkeleton;